import { get } from 'svelte/store';
import type { Project } from '../types';
import { createPopoverStore } from './createPopoverStore';
import { popoversAreSheets } from '../sheetPopover';

export interface ProjectCellPopoverState {
  projects: Project[];
  anchorEl: HTMLElement;
  /** Label shown in popover header (e.g. "Jan 2026" or "Week 5") */
  label: string;
}

const store = createPopoverStore<ProjectCellPopoverState>({
  showDelay: 80,
  hideDelay: 200,
  sheetMode: popoversAreSheets,
});

export const projectCellPopoverState = store.state;

/**
 * Show the project cell popover.
 * Called when hovering over the "+N more" chip.
 */
export function showProjectCellPopover(projects: Project[], label: string, anchorEl: HTMLElement) {
  const current = get(projectCellPopoverState);

  // If already showing for same anchor, just cancel any pending hide and skip
  if (current && current.anchorEl === anchorEl) {
    store.cancelHide();
    return;
  }

  store.show({ projects, label, anchorEl });
}

/**
 * Hide the project cell popover.
 */
export function hideProjectCellPopover(immediate = false) {
  store.hide(immediate);
}

/**
 * Called when cursor enters the popover element itself.
 */
export function enterProjectCellPopover() {
  store.enterPopover();
}

/**
 * Called when cursor leaves the popover element.
 */
export function leaveProjectCellPopover() {
  store.leavePopover();
}
